import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import Layout from "../../layouts/default";
import CampaignFooter from "../../components/Campaigns/CampaignFooter";
import ProgressBar from "../../components/Campaigns/ProgressBar";

import { saveCampaignSettingThunkApi } from "../../store/slices/campaigns/campaign";
import { loadCampaign, updateCampaign } from "../../store/slices/campaigns/createCampaign";
import { getCampaigns } from "../../store/slices/campaigns/campaigns";

const SetCampaignSetting = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { campaign, updateCampData } = useSelector(
        (state) => state.createCampaignSlice
    );
    const [isRepeatCampaign, setIsRepeatCampaign] = useState(campaign?.data?.isRepeat || false);

    const [dailyLimit, setDailyLimit] = useState("");

    useEffect(() => {
        if (id) {
            dispatch(loadCampaign(id));
        }
    }, [id, dispatch]);

    useEffect(() => {
        if (campaign?.data?.setting?.daily_limit) {
            setDailyLimit(campaign.data.setting.daily_limit);
        }

        if (campaign?.data) {
            setIsRepeatCampaign(campaign.data.isRepeat);
        }
    }, [campaign]);

    const submitHandler = async () => {
        const limit = Number(dailyLimit);

        if (!limit || limit < 1) {
            toast.error("Daily contact upload limit must be greater than 0");
            return;
        }

        const campaignId = campaign?.data?.id;
        if (!campaignId) {
            toast.error("Campaign not found. Please reload and try again");
            return;
        }

        const payload = {
            campaign_id: campaignId,
            daily_limit: limit,
        };

        try {
            const res = await dispatch(saveCampaignSettingThunkApi(payload)).unwrap();
            toast.success(res || "Campaign settings saved successfully");
            dispatch(getCampaigns({ page: 1, filterData: "" }));
            navigate("/campaigns");
        } catch (err) {
            console.log("Error : ", err);
            console.error(err);
            toast.error("Failed to save campaign settings");
        }
    };


    const handleSaveAndContinue = async (path, status) => {
        await submitHandler();
        if (isRepeatCampaign) {
            navigate(path);
        } else {
            let campaignPayload = {
                id: campaign?.data.id,
                status: status === 'draft' ? 'draft' : 'published'
            }
            //update campaign status
            dispatch(updateCampaign(campaignPayload))
        }
    };

    return (
        <Layout>
            <Row>
                <Col md={8}>
                    <div className="pageHeader mb-5">
                        <h3 className="smallHeading mb-3">Create Campaign</h3>
                        <h1>Campaign Settings</h1>
                    </div>

                    <div className="progressSteps mt-4">
                        <Row className="mb-3">
                            <Col sm={5}>
                                <label className="form-label">
                                    Daily Contact Upload Limit
                                </label>
                            </Col>
                            <Col sm={7}>
                                <input
                                    type="number"
                                    min="1"
                                    className="form-control"
                                    value={dailyLimit}
                                    onChange={(e) => setDailyLimit(e.target.value)}
                                    placeholder="e.g. 5000"
                                />
                            </Col>
                        </Row>

                        <p className="text-muted">
                            This limit controls how many contacts can be uploaded and processed
                            per day for this campaign.
                        </p>
                    </div>

                    <div style={{ marginTop: '20%' }}>
                        <CampaignFooter
                            nextStep="Schedule and Publish"
                            buttonTitle={isRepeatCampaign ? "Save Setting" : "Save and Publish"}
                            onNextStepHandler={(status) => {
                                handleSaveAndContinue(
                                    `/campaigns/edit/schedule/${campaign?.data?.id}`, status
                                )
                            }
                            }
                            showDraft={!campaign?.data?.isRepeat}
                        />
                    </div>

                </Col>

                <Col md={4}>
                    <ProgressBar
                        campaign={campaign}
                        updateCampData={updateCampData}
                    />
                </Col>
            </Row>
        </Layout>
    );
};

export default SetCampaignSetting;
